<template>
  <div
    ref="dnd__wrapper"
    class="wrapper"
  >
    <folder-header :folder="model" />
    <drop-list
      :key="model.folderGuid"      
      :items="model.children"
      class="content__wrapper"
      mode="cut"
      direction="column"
      :reordering-feedback="true"
      @reorder="onReorder"
    >
      <template
        v-if="!isDragModeEnabled"
        #item="{ item, index }"
      >
        <drag
          :key="item.label"
          :model="item"
          :data="item"
          :drag-image-opacity="1"
          @cut="remove(item)"
        >
          <component
            :is="getCurrentComponent"
            v-bind="getCurrentProps(item, index)"
          />
          <template #drag-image>
            <div class="drag-image">
              {{ item.label }}
            </div>
          </template>
        </drag>
      </template>
      <template
        v-if="showAdvancedSettings"
        #feedback="{ data }"
      >
        <div
          :key="data.moduleGuid"
          class="feedback"
        >
          <font-awesome-icon :icon="['fas', data.icon || 'table']" />
          {{ data.label }}
        </div>
      </template>
    </drop-list>
  </div>
</template>

<script>
import {Drag, DropList} from 'vue-easy-dnd';
import ModuleCard from '@/modules/DataManagement/views/module/components/ModuleCard.vue';
import FolderHeader from '@/modules/DataManagement/views/module/components/FolderHeader.vue';
import {createNamespacedHelpers} from 'vuex';
import NewTableItem from '@/modules/DataManagement/views/module/components/NewTableItem.vue';

const {
  mapState: sidebarMapState,
  mapActions: sidebarMapActions,
} = createNamespacedHelpers('sidebar');

const entityTypes = {
  MODULE: 'module',
  FOLDER: 'folder',
  TABLE: 'table',
};
export default {
  name: 'DNDCardsGrid',
  components: {
    FolderHeader,
    ModuleCard,
    Drag,
    DropList,
    NewTableItem,
  },
  props: [
    'model',
    'type',
    'showAdvancedSettings',
  ],
  data() {
    return {
      items: null,
    };
  },
  computed: {
    ...sidebarMapState({
      isDragModeEnabled: state => state.isDragModeEnabled,
    }),
    currentRequest() {
      switch (this.type) {
      case entityTypes.MODULE:
        return this.updateModuleSortOrder;
      case entityTypes.TABLE:
        return this.updateTableSortOrder;
      }
    },
    getCurrentComponent() {
      return this.type === entityTypes.MODULE ? ModuleCard : NewTableItem;
    },
  },
  methods: {
    ...sidebarMapActions([
      'updateModuleSortOrder',
      'updateTableSortOrder',
    ]),
    getCurrentProps(item, idx) {
      return this.type === entityTypes.MODULE
        ? {module: item}
        : {table: item, idx};
    },
    async onReorder(e) {
      e.apply(this.model.children);
      const isSuccess = await this.currentRequest(this.model);
      this.$toasted[isSuccess ? 'success' : 'error'](
        isSuccess
          ? 'Items reordered successfully'
          : 'Something went wrong'
        , {duration: TOASTER_DURATION},
      );
    },
    remove(item) {
      const index = this.model.children.indexOf(item);
      this.model.children.splice(index, 1);
    },
  },
};
</script>

<style scoped lang="scss">
.wrapper {
  .content__wrapper {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 1rem;
    align-items: stretch;
  }

  .drag-image {
    padding: 10px;
    border-radius: 6px;
    background-color: #0F355E;
    color: white;
  }

  .feedback {
    padding: 1.25rem;
    color: white;
    background-color: rgba(15, 53, 94, 0.8);
    font-size: 1.06rem;
  }
}
</style>